import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Icon } from "semantic-ui-react";

import { classNames } from "utils/common";

import type { CSSProperties } from "react";

type SortableConfigItemProps = {
  sortableId: string;
  text: string;
  canEdit: boolean;
  onRemove: () => void;
};

export const SortableConfigItem = ({ sortableId, text, canEdit, onRemove }: SortableConfigItemProps) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: sortableId });

  const style: CSSProperties = { transform: CSS.Translate.toString(transform), transition };

  return (
    <div ref={setNodeRef} style={style} className={`config-item ${classNames({ "is-sortable": canEdit, "is-dragging": isDragging })}`} {...attributes} {...listeners}>
      {canEdit && <Icon className="xmark" onClick={onRemove} />}
      <span>{text}</span>
    </div>
  );
};
